import { Badge } from '@/components/ui/badge';
import type { ChatRole } from '@/features/votes/chat-message';

import CopyableId from './CopyableId';

const ROLE_LABEL: Record<ChatRole, string> = {
  user: 'User',
  assistant: 'Assistant',
  tool: 'Tool',
};

export default function MessageHeader({
  role,
  agent,
  id,
  highlightLabel,
}: {
  role: ChatRole;
  agent?: string;
  id?: string;
  highlightLabel?: string;
}) {
  const showAgent = agent && role !== 'user';
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        {ROLE_LABEL[role]}
      </span>
      {showAgent && (
        <code className="font-mono text-[11px] text-muted-foreground/80">
          {agent}
        </code>
      )}
      {id && <CopyableId value={id} />}
      {highlightLabel && (
        <Badge className="bg-primary text-[11px] text-primary-foreground">
          {highlightLabel}
        </Badge>
      )}
    </div>
  );
}
